<template>
<svg data-svg-lvl-2="spread-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430">
<PreviewLayersSpreadBlockShadowDH :params="params" v-if="!params.isFlap7" />
<PreviewLayersSpreadBlockShadowDH_F7 :params="params" v-if="params.isFlap7" />
<PreviewLayersSpreadBlockSpreadDH :params="params" v-if="!params.isFlap7" />
<PreviewLayersSpreadBlockSpreadDH_F7 :params="params" v-if="params.isFlap7" />
<PreviewLayersSpreadBlockInsertsDH :params="params" v-if="!params.isFlap7 && params.isInserts" />
<PreviewLayersSpreadBlockInsertsDH_F7 :params="params" v-if="params.isFlap7 && params.isInserts" />
<PreviewLayersSpreadBlockContourDH :params="params" v-if="!params.isFlap7" />
<PreviewLayersSpreadBlockContourDH_F7 :params="params" v-if="params.isFlap7" />
<component :params="params" :is="`PreviewLayersSpreadBlockLasseRD`" v-if="params.isLasse" />
<component :params="params" :is="`PreviewLayersSpreadBlockLasseRDS`" v-if="params.isLasseSilicon" />
<component :params="params" :is="`PreviewLayersSpreadBlockLasseNameplate${params.lasseNameplateComponent}`" v-if="params.lasseNameplateComponent" />
</svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>